import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { apis, apiHolder as api, mailPerfTool, inWindow, MailSettingKeys, getIn18Text, } from 'api';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { Button } from 'antd';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import { getParameterByName, idIsTreadMail } from '@web-common/utils/utils';
import { useAppSelector, useActions, useAppDispatch } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { MailActions } from '@web-common/state/reducer';
import { HotKeysType } from '@web-common/state/reducer/hotkeysReducer';
import useDebounceForEvent from '@web-common/hooks/useDebounceForEvent';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import useGetUniqReqWrap, { ERROR_REQUEST_CANCLE } from '@web-common/hooks/useGetUniqReqWrap';
import { filterSysMailTag, combineContent, changeContentByLocal, getMailFromMails, createLangKey } from '@web-mail/util';
import { THREAD_MAIL_PAGE_SIZE, TASK_MAIL_STATUS, MAIL_HOTKEY_MODULE_TYPE } from '@web-mail/common/constant';
import { getTranslateErrorMsg, isSupportOriginLang } from '../TranslateTips/errCodeMsg';
import MergeMail from './MergeMail';
import SingleMail from './SingleMail';
import MailDetailLoading from './component/Loadings';
import useFixedScroolBar from './useFixedScrollBar';
import HorizontalScrollBar from './component/VScrollBar/scrollBar';
import useMailStoreState from '@web-mail/hooks/useMailStoreState';
import useMailStore from '@web-mail/hooks/useMailStoreRedux';
import useStateRef from '@web-mail/hooks/useStateRef';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { HotKeys } from '@web-mail/common/library/HotKeys/react-hotkeys';
import { useRegistMailHK } from '@web-mail/components/ListHotKeys/moduleHotKey';
import AttachmentPreview from '@web-mail/components/AttachmentPreview';
import './index.scss';
import useUpdateEffectWithKey from '@web-common/hooks/useUpdateEffectWithKey';
import { tabId, tabType } from '@web-common/state/reducer/mailTabReducer';
import { useState2SubordinateSlice } from '@web-mail/hooks/useState2SliceRedux';
import { safeHTML } from '@web-common/utils/xssUtils';
var MAIL_LOAD_STATUS;
(function (MAIL_LOAD_STATUS) {
    MAIL_LOAD_STATUS["SUCCESS"] = "SUCCESS";
    MAIL_LOAD_STATUS["FAIL"] = "FAIL";
    MAIL_LOAD_STATUS["LOADING"] = "LOADING";
    MAIL_LOAD_STATUS["EMPTY"] = "EMPTY";
})(MAIL_LOAD_STATUS || (MAIL_LOAD_STATUS = {}));
export var ListHotKey;
(function (ListHotKey) {
    ListHotKey["COMMAND_F"] = "COMMAND_F";
})(ListHotKey || (ListHotKey = {}));
export const keyMap = {
    [ListHotKey.COMMAND_F]: ['command+f', 'ctrl+f'],
};
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const eventApi = api.api.getEventApi();
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const aiAssistantApi = api.api.requireLogicalApi(apis.aiAssistant);
const DefaultThreadPageConfig = {
    current: 1,
    pageSize: THREAD_MAIL_PAGE_SIZE,
    total: 0,
};
const defaultFeatureConfig = {
    mailDiscuss: true,
    relatedMail: true,
    mailTagIsCloseAble: true,
    readStatus: true,
};
const ReadMail = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { mailId, from, openInNewWindow = false, nonAttachment = false, tempContent, readOnly = false, isUpDown, emptyRender, failRender, loadingRender, getSignMailContent, featureConfig = defaultFeatureConfig, requestUniqWrap, contactType, sliceId, source = 'normal', visible, hotKey = false, readmailFrom, } = props;
    const mailAccount = useMemo(() => {
        return typeof mailId === 'string' ? '' : mailId === null || mailId === void 0 ? void 0 : mailId.account;
    }, [mailId]);
    const id = useMemo(() => {
        return typeof mailId === 'string' ? mailId : mailId === null || mailId === void 0 ? void 0 : mailId.id;
    }, [mailId]);
    const localFeatureConfig = useMemo(() => {
        return Object.assign(Object.assign({}, defaultFeatureConfig), featureConfig);
    }, [featureConfig]);
    const [content, setContent] = useMailStoreState(null, false);
    const contentRef = useStateRef(content);
    const [readStatus, setReadStatus] = useState();
    const [openRecordData, setOpenRecordData] = useState();
    const [activeKey, setActiveKey] = useState([]);
    const [mailList, _setMailList] = useMailStore('readMailChildMailList');
    const mailListRef = useStateRef(mailList);
    const shouldAutoReadMail = mailConfApi.getShouldAutoReadMailSync();
    const setMailList = useCreateCallbackForEvent(list => {
        if (!(isEmpty(mailList) && isEmpty(list))) {
            _setMailList(list);
        }
    });
    const mailIdChangeRecord = useRef(null);
    const [threadPageConfig, setThreadPageConfig] = useState(Object.assign({}, DefaultThreadPageConfig));
    const threadPageConfigRef = useStateRef(threadPageConfig);
    const [loadStatus, setLoadStatus] = useState(MAIL_LOAD_STATUS.EMPTY);
    const [loadFailError, setLoadFailErr] = useState();
    const fnUniqWarp = requestUniqWrap || useGetUniqReqWrap();
    const cancelContent = fnUniqWarp(() => Promise.resolve(''));
    const doGetThreadMailContent = fnUniqWarp(mailApi.doGetThreadMailContent.bind(mailApi));
    const doGetMailContent = fnUniqWarp(getSignMailContent ? getSignMailContent : mailApi.doGetMailContent.bind(mailApi));
    const isCustomRequest = useStateRef(!!getSignMailContent);
    const [isThreadMail, setIsThreadMail] = useState();
    const [translateInfoMidMap, setTranslateInfoMidMap] = useState({});
    const translateInfoMidMapRef = useStateRef(translateInfoMidMap);
    const [threadMailIds, setThreadMailIds] = useState([]);
    const [mergeMailOrderDesc, setMergeMailOrderDesc] = useState2RM('mergeMailOrderDesc');
    const mergeMailOrderDescRef = useStateRef(mergeMailOrderDesc);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const taskStatus = useAppSelector(state => state.readMailReducer.taskDetail.status);
    const guidePage = useAppSelector(state => state.mailReducer.onGuidePage);
    const requestReadReceiptLocal = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.mailEntities[id]) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.requestReadReceiptLocal; });
    const dispatch = useAppDispatch();
    const mailActions = useActions(MailActions);
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const [searchInputVisible, setSearchInputVisible] = useState(false);
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const isSubordinateTab = useMemo(() => currentTabId === tabId.subordinate || currentTabType === tabType.subordinate, [currentTabId, currentTabType]);
    const [mailSearchState] = useState2SubordinateSlice('mailSearchState');
    const { WrapCompenent, VrticalScrollWrapComponent, ContentMeasurement, handleVScrollOnScroll, vScrollBarShow, vScrollBarLeft, vScrollBarWidth, vScrollBarViewWidth, } = useFixedScroolBar({
        contentRectBottomOffset: 24,
    });
    const [forceUpdate, setForceUpdate] = useState(0);
    const [freezeMouse, setFreezeMouse] = useState(false);
    const mailIdList = useMemo(() => {
        if (mailList && mailList.length) {
            let res = '';
            return mailList.forEach(item => {
                res += item === null || item === void 0 ? void 0 : item.id;
            });
            return res;
        }
        return '';
    }, [mailList]);
    useUpdateEffectWithKey(() => {
        setForceUpdate(count => count + 1);
    }, [requestReadReceiptLocal], (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id);
    useUpdateEffectWithKey(() => {
        var _a, _b;
        if ((_b = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.langListMap) === null || _b === void 0 ? void 0 : _b.originLang) {
            setForceUpdate(count => count + 1);
        }
    }, [(_c = (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.langListMap) === null || _c === void 0 ? void 0 : _c.originLang], (_d = content === null || content === void 0 ? void 0 : content.entry) === null || _d === void 0 ? void 0 : _d.id);
    const preContentId = useRef('');
    useEffect(() => {
        if ((content === null || content === void 0 ? void 0 : content.isThread) && content.id === preContentId.current && threadPageConfigRef.current.current == 1) {
            let requestParam = {
                desc: mergeMailOrderDescRef.current,
                start: 0,
                limit: threadPageConfigRef.current.pageSize,
            };
            let noCache = true;
            getThreadMailContent(requestParam, noCache);
        }
        preContentId.current = content === null || content === void 0 ? void 0 : content.id;
    }, [content === null || content === void 0 ? void 0 : content.isThread, (_e = content === null || content === void 0 ? void 0 : content.entry) === null || _e === void 0 ? void 0 : _e.threadMessageCount, content === null || content === void 0 ? void 0 : content.id]);
    const fromType = useMemo(() => {
        let type = '';
        if (id) {
            type = 'inner';
            if (openInNewWindow) {
                type = getParameterByName('push', window.location.search) === '1' || from === 'push' ? 'push' : 'window';
            }
        }
        return type;
    }, [id, openInNewWindow]);
    const setLoadStatusHandler = (status) => {
        setLoadStatus(status);
        aiAssistantApi.sendNotification({ type: 'readMail', data: status });
    };
    const setData = useCreateCallbackForEvent((_content, recordPerf = false) => {
        var _a;
        setContent(_content);
        setLoadStatusHandler(MAIL_LOAD_STATUS.SUCCESS);
        if (recordPerf && fromType) {
            mailPerfTool.mailContent(fromType, 'end', {
                mid: _content.id.split('--')[0],
                isThread: fromType === 'push' ? false : !!(_content === null || _content === void 0 ? void 0 : _content.isThread),
                folder: (_content === null || _content === void 0 ? void 0 : _content.entry.folder) || undefined,
                read: fromType !== 'push' && ((_a = _content === null || _content === void 0 ? void 0 : _content.entry) === null || _a === void 0 ? void 0 : _a.readStatus) === 'read',
            });
        }
    });
    const getThreadMailContent = useCallback((requestParam, noCache) => {
        if (!id) {
            setLoadStatusHandler(MAIL_LOAD_STATUS.SUCCESS);
            return;
        }
        const isThread = idIsTreadMail(id);
        doGetThreadMailContent(id, requestParam, noCache, threadMailIds, mailAccount)
            .then((res) => {
            if (!res || !res.length) {
                setLoadStatusHandler(MAIL_LOAD_STATUS.SUCCESS);
                return;
            }
            if (res.length === 1) {
                doGetMailContent(res[0].id, false, false, undefined, { _account: mailAccount })
                    .then((_content) => {
                    var _a, _b;
                    const noSysTagContent = filterSysMailTag(_content);
                    res[0] = noSysTagContent;
                    if (isCorpMail) {
                        noSysTagContent.isThread = isThread;
                        setData(noSysTagContent, true);
                    }
                    setMailList(res);
                    handleTranslateInfo(noSysTagContent);
                    setActiveKey([(_a = _content === null || _content === void 0 ? void 0 : _content.entry) === null || _a === void 0 ? void 0 : _a.id]);
                    shouldAutoReadMail && ((_b = _content === null || _content === void 0 ? void 0 : _content.entry) === null || _b === void 0 ? void 0 : _b.readStatus) === 'unread' && handleRemark(true, _content === null || _content === void 0 ? void 0 : _content.id, 'read', true);
                })
                    .catch((err) => {
                    if (err !== ERROR_REQUEST_CANCLE) {
                        setLoadStatusHandler(MAIL_LOAD_STATUS.FAIL);
                        setLoadFailErr(err);
                        trackApi.track('pc_readmail_content_load_failed', {
                            error: err,
                            from: 'doGetThreadMailContent-doGetMailContent',
                            isCustomRequest: isCustomRequest,
                        });
                    }
                });
            }
            else {
                if (isCorpMail) {
                    setData(res[0], true);
                }
                setMailList(res);
            }
            setLoadStatusHandler(MAIL_LOAD_STATUS.SUCCESS);
        })
            .catch((err) => {
            if (err !== ERROR_REQUEST_CANCLE) {
                trackApi.track('pc_readmail_content_load_failed', {
                    error: err,
                    from: 'doGetThreadMailContent-doGetThreadMailContent',
                });
            }
        });
    }, [id, threadMailIds]);
    const handlePageChange = useCallback((page) => {
        setThreadPageConfig(Object.assign(Object.assign({}, threadPageConfig), { current: page }));
        const pageSize = threadPageConfig.pageSize || THREAD_MAIL_PAGE_SIZE;
        let requestParam = {
            desc: mergeMailOrderDescRef.current,
            start: pageSize * (page - 1 > 0 ? page - 1 : 0),
            limit: pageSize,
        };
        let noCache = false;
        if (isCorpMail) {
            noCache = true;
        }
        setActiveKey([]);
        getThreadMailContent(requestParam, noCache);
    }, [threadPageConfig, getThreadMailContent]);
    const handleTranslateInfo = useCallback((content) => {
        var _a;
        const transMailId = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id;
        if (transMailId) {
            setTranslateInfoMidMap(Object.assign(Object.assign({}, translateInfoMidMapRef.current), { [transMailId]: { status: 'none' } }));
        }
    }, []);
    const handleTranslateData = useCreateCallbackForEvent(async (transMailId, toLang, fromLang) => {
        var _a, _b;
        if (((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id) == transMailId) {
            const newContent = await getTranslateContent(transMailId, toLang, fromLang);
            if (newContent) {
                setData(newContent);
            }
            return;
        }
        if ((content === null || content === void 0 ? void 0 : content.isThread) && ((_b = mailListRef.current) === null || _b === void 0 ? void 0 : _b.length)) {
            const index = mailListRef.current.findIndex(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id) == transMailId; });
            if (index > -1) {
                const newContent = await getTranslateContent(transMailId, toLang, fromLang);
                if (newContent) {
                    const list = [...mailListRef.current];
                    list[index] = newContent;
                    setMailList(list);
                }
            }
        }
    });
    const transMailContent = useMemo(() => {
        if (content && content.entry.langType && content.entry.langListMap) {
            const langListMap = content.entry.langListMap;
            const langType = content.entry.langType;
            const result = langListMap[langType];
            if (result) {
                return changeContentByLocal(langType, result, content);
            }
        }
        return content;
    }, [content, (_g = (_f = content === null || content === void 0 ? void 0 : content.entry) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.content, (_h = content === null || content === void 0 ? void 0 : content.entry) === null || _h === void 0 ? void 0 : _h.langType, content === null || content === void 0 ? void 0 : content.isDecrypted]);
    const getMailContentById = useCallback((transMailId) => {
        var _a, _b;
        if (((_a = transMailContent === null || transMailContent === void 0 ? void 0 : transMailContent.entry) === null || _a === void 0 ? void 0 : _a.id) == transMailId) {
            return transMailContent;
        }
        return (_b = mailListRef.current) === null || _b === void 0 ? void 0 : _b.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id) == transMailId; });
    }, [transMailContent]);
    const getFromAndToLang = useCallback((_content, toLang, fromLang) => {
        var _a, _b;
        let systemLang = navigator.language === 'zh-CN' ? 'zh-CHS' : navigator.language;
        const originLang = (_b = (_a = _content === null || _content === void 0 ? void 0 : _content.entry) === null || _a === void 0 ? void 0 : _a.langListMap) === null || _b === void 0 ? void 0 : _b.originLang;
        let to = toLang;
        let from = fromLang || originLang;
        const isOrigin = toLang === 'origin';
        if (toLang === 'current') {
            from = originLang;
            to = systemLang;
        }
        return { from: from || 'auto', to: to || systemLang, isOrigin };
    }, []);
    const doTranslateContentByNet = useCallback(async (content, from, to) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        setTranslateInfoData(content.id, { status: 'process' });
        let contentC = ((_b = (_a = content.entry) === null || _a === void 0 ? void 0 : _a.langListMap) === null || _b === void 0 ? void 0 : _b.origin) || ((_d = (_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.content);
        const storeLangKey = createLangKey(from, to);
        try {
            contentC = contentC.replaceAll(/<[^>]*>/g, m => m.replaceAll('\n', ''));
            contentC = contentC.replaceAll('\n', '<br data="n">');
        }
        catch (e) {
            console.error('[Err doTranslateContentByNet Reg 1]', e);
        }
        let combineTitleAndContent = ((_f = (_e = content.entry) === null || _e === void 0 ? void 0 : _e.langListMap) === null || _f === void 0 ? void 0 : _f.origin) ? contentC : combineContent(content.entry.title, contentC);
        let newContent = cloneDeep(content);
        try {
            const res = await mailApi.getTranslateContent(combineTitleAndContent, from, to);
            trackApi.track('pcmail_readmail_translate', {
                result: res.code === 0,
                version: productVersionId,
            });
            if (res.code === 0) {
                let translation = ((_g = res.data) === null || _g === void 0 ? void 0 : _g.translation[0]) || '';
                try {
                    translation = translation.replaceAll('<br data="n">', '\n');
                }
                catch (e) {
                    console.error('[Err doTranslateContentByNet Reg 2]', e);
                }
                newContent = changeContentByLocal(storeLangKey, translation, newContent);
                if (newContent.entry.langListMap) {
                    newContent.entry.langListMap[storeLangKey] = translation;
                }
                setTranslateInfoData((_h = content === null || content === void 0 ? void 0 : content.entry) === null || _h === void 0 ? void 0 : _h.id, { status: 'none' });
                if (!content.isTpMail) {
                    mailApi.syncTranslateContentToDb(content.id, storeLangKey, translation, mailAccount);
                }
            }
            else {
                setTranslateInfoData((_j = content === null || content === void 0 ? void 0 : content.entry) === null || _j === void 0 ? void 0 : _j.id, {
                    status: 'error',
                    errorMessage: getTranslateErrorMsg(res.code, res.message),
                });
                Toast.error(getTranslateErrorMsg(res.code, res.message));
            }
        }
        catch (err) {
            setTranslateInfoData((_k = content === null || content === void 0 ? void 0 : content.entry) === null || _k === void 0 ? void 0 : _k.id, {
                status: 'error',
                errorMessage: getTranslateErrorMsg(),
            });
            Toast.error(getTranslateErrorMsg());
        }
        return newContent;
    }, [mailAccount]);
    const setTranslateInfoData = useCallback((transMailId, data) => {
        setTranslateInfoMidMap(Object.assign(Object.assign({}, translateInfoMidMapRef.current), { [transMailId]: data }));
    }, []);
    const getTranslateContent = useCreateCallbackForEvent(async (transMailId, toLang, fromLang) => {
        const _content = getMailContentById(transMailId);
        if (!_content) {
            return null;
        }
        const { from, to, isOrigin } = getFromAndToLang(_content, toLang, fromLang);
        if (!isOrigin && !isSupportOriginLang(from)) {
            Toast.error('可能不支持该语言的翻译，请手动选择要翻译的语言类型');
            return null;
        }
        const langListMap = _content.entry.langListMap;
        const isTpMail = _content.isTpMail;
        const storeLangKey = isOrigin ? 'origin' : createLangKey(from, to);
        const memoryLangData = langListMap && langListMap[storeLangKey];
        if (!memoryLangData) {
            return doTranslateContentByNet(_content, from, to);
        }
        if (isTpMail) {
            setTranslateInfoData(transMailId, { status: 'none' });
            return changeContentByLocal(storeLangKey, memoryLangData, _content);
        }
        try {
            const saveSuccess = await mailApi.syncTranslateContentToDb(transMailId, storeLangKey, undefined, mailAccount);
            if (saveSuccess) {
                setTranslateInfoData(transMailId, { status: 'none' });
                return changeContentByLocal(storeLangKey, memoryLangData, _content);
            }
        }
        catch (error) {
            console.error('[getTranslateContent error', error);
        }
        return doTranslateContentByNet(_content, from, to);
    });
    const handleIdChange = useCallback(async () => {
        var _a, _b, _c, _d;
        try {
        }
        catch (e) {
            console.error('[readmail track error]:', e);
        }
        setReadStatus(undefined);
        if (!id) {
            setLoadStatusHandler(MAIL_LOAD_STATUS.EMPTY);
            cancelContent();
            setContent(null);
            contentRef.current = null;
            setThreadMailIds([]);
            setMailList([]);
            return;
        }
        const isThread = idIsTreadMail(id);
        setIsThreadMail(isThread);
        if (!isEmpty(mailList)) {
            setMailList([]);
        }
        if (fromType === 'inner') {
            mailPerfTool.mailContent(fromType, 'start', { isThread: isThread });
        }
        if (id && contentRef.current == null) {
            setLoadStatusHandler(MAIL_LOAD_STATUS.LOADING);
        }
        if (isThread) {
            setThreadPageConfig(Object.assign({}, DefaultThreadPageConfig));
            setActiveKey(list => {
                if (isEmpty(list)) {
                    return list;
                }
                return [];
            });
            if (!isCorpMail) {
                const account = typeof mailId === 'string' ? '' : mailId === null || mailId === void 0 ? void 0 : mailId.account;
                mailApi.doGetThreadMailById(id, account || mailAccount).then(_content => {
                    var _a;
                    if (_content && _content.id === id) {
                        setData(filterSysMailTag(_content), true);
                        setThreadPageConfig(Object.assign(Object.assign({}, DefaultThreadPageConfig), { total: (_a = _content === null || _content === void 0 ? void 0 : _content.entry) === null || _a === void 0 ? void 0 : _a.threadMessageCount }));
                        let requestParam = {
                            desc: mergeMailOrderDescRef.current,
                            start: 0,
                            limit: threadPageConfig.pageSize,
                        };
                        let noCache = false;
                        if (isCorpMail) {
                            noCache = true;
                            requestParam = {
                                desc: mergeMailOrderDescRef.current,
                                start: 0,
                                limit: threadPageConfig.pageSize,
                            };
                        }
                        getThreadMailContent(requestParam, noCache);
                    }
                });
            }
            else {
                getThreadMailContent({
                    desc: mergeMailOrderDescRef.current,
                }, true);
            }
        }
        else {
            const account = typeof mailId === 'string' ? '' : mailId === null || mailId === void 0 ? void 0 : mailId.account;
            const isMarkedRead = ((_a = tempContent === null || tempContent === void 0 ? void 0 : tempContent.entry) === null || _a === void 0 ? void 0 : _a.readStatus) === 'read';
            const needMarkRead = (!(tempContent === null || tempContent === void 0 ? void 0 : tempContent.localFilePath) && !id.startsWith('eml-')) || ((_b = tempContent === null || tempContent === void 0 ? void 0 : tempContent.entry) === null || _b === void 0 ? void 0 : _b.readStatus) === 'unread';
            console.log('doMarkMail in Readmail start', isMarkedRead, needMarkRead);
            if (needMarkRead && !isMarkedRead) {
                try {
                    if (shouldAutoReadMail) {
                        handleRemark(true, id, 'read', true);
                    }
                    if (process.env.BUILD_ISEDM) {
                        contactType && trackApi.track('waimao_mail_viewUnread_mailDetailPage', { cardType: contactType });
                    }
                }
                catch (e) {
                    console.error('error when read and mark', e);
                }
            }
            else {
                if (shouldAutoReadMail) {
                    recordMailRead(id);
                }
            }
            doGetMailContent(id, false, false, undefined, {
                noContactRace: !!((_d = (_c = tempContent === null || tempContent === void 0 ? void 0 : tempContent.entry) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.content),
                _account: account || mailAccount,
            })
                .then((_content) => {
                var _a;
                mailActions.doUpdateShowGlobalLoading(false);
                const noSysTagContent = filterSysMailTag(_content);
                const noSysTagContentEntry = (noSysTagContent === null || noSysTagContent === void 0 ? void 0 : noSysTagContent.entry) || {};
                const readContent = Object.assign(Object.assign({}, noSysTagContent), { entry: Object.assign(Object.assign({}, noSysTagContentEntry), (shouldAutoReadMail && !_content.isTpMail ? { readStatus: 'read' } : {})) });
                if (isSubordinateTab && !!mailSearchState) {
                    readContent.entry.brief = ((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.entry.brief) || readContent.entry.brief || '';
                }
                setData(readContent, true);
                setMailList([readContent]);
                handleTranslateInfo(readContent);
            })
                .catch((err) => {
                console.error('error in read content', err);
                if (err !== ERROR_REQUEST_CANCLE) {
                    (err === null || err === void 0 ? void 0 : err.title) && Toast.error({ content: err === null || err === void 0 ? void 0 : err.title });
                    setLoadStatusHandler(MAIL_LOAD_STATUS.FAIL);
                    setLoadFailErr(err);
                    trackApi.track('pc_readmail_content_load_failed', {
                        error: err,
                        from: 'handleIdChange-doGetMailContent',
                        isCustomRequest: isCustomRequest,
                    });
                }
            });
        }
    }, [id, tempContent, mailList, mailAccount, isSubordinateTab, mailSearchState]);
    const handleMailEncodingChange = useCallback((e) => {
        if (e && e.eventStrData && e.eventStrData === 'mailEncoding') {
            const { mid, encoding, account } = e.eventData;
            if (isThreadMail) {
                if (mailListRef.current && mailListRef.current.length) {
                    const localMailList = [...mailListRef.current];
                    const index = localMailList.findIndex(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id) === mid; });
                    if (index >= 0) {
                        mailApi.doChangeMailEncoding(mid, encoding, { _account: account }).then(newContent => {
                            const noSysTagContent = filterSysMailTag(newContent);
                            localMailList.splice(index, 1, noSysTagContent);
                            _setMailList(localMailList);
                            setForceUpdate(count => count + 1);
                        });
                    }
                }
            }
            else {
                mailApi.doChangeMailEncoding(mid, encoding, { _account: account }).then(newContent => {
                    const noSysTagContent = filterSysMailTag(newContent);
                    setContent(noSysTagContent);
                    setForceUpdate(count => count + 1);
                });
            }
        }
    }, [isThreadMail, mailIdList, mergeMailOrderDesc]);
    const handleTranslateChanged = useCallback((ev) => {
        var _a;
        const { eventStrData, eventData } = ev;
        const transMailId = eventData.id;
        let idIsBelongCurMail = false;
        if (transMailId == ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id)) {
            idIsBelongCurMail = true;
        }
        else if ((content === null || content === void 0 ? void 0 : content.isThread) && mailList && mailList.length) {
            idIsBelongCurMail = mailList.some(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id) == transMailId; });
        }
        if (idIsBelongCurMail) {
            if (eventStrData === 'translate') {
                handleTranslateData(transMailId, 'current');
            }
            else if (eventStrData === 'cancelTranslate') {
                handleTranslateData(transMailId, 'origin');
            }
        }
    }, [content, mailList]);
    useMsgRenderCallback('mailTranslateChanged', handleTranslateChanged);
    useMsgRenderCallback('mailMenuOper', handleMailEncodingChange);
    const onDelete = useCallback((_id, params) => {
        dispatch(Thunks.deleteMail({
            id: _id,
            showLoading: params === null || params === void 0 ? void 0 : params.showLoading,
            isScheduleSend: params === null || params === void 0 ? void 0 : params.isScheduleSend,
            detail: params === null || params === void 0 ? void 0 : params.detail,
        }))
            .unwrap()
            .then((res) => {
            const { payload } = res;
            if (payload === null || payload === void 0 ? void 0 : payload.succ) {
                if (openInNewWindow) {
                    if (systemApi.isElectron()) {
                        setTimeout(() => {
                            systemApi.closeWindow();
                        }, 300);
                    }
                    else {
                        window.close();
                    }
                }
            }
        });
    }, [openInNewWindow]);
    const onMark = useCallback((_mark, _id, type, hideMessage) => {
        let messageType = '';
        if (type === 'read') {
            messageType = _mark ? 'read' : 'unread';
        }
        else if (type === 'redFlag') {
            messageType = _mark ? 'mark' : 'unmark';
        }
        eventApi.sendSysEvent({
            eventName: 'mailStatesChanged',
            eventData: {
                mark: _mark,
                id: _id,
                type,
                hideMessage,
                ids: threadMailIds,
            },
            _account: mailAccount,
            eventStrData: messageType,
        });
    }, [mailAccount, threadMailIds]);
    const handleRemark = useCreateCallbackForEvent((_mark, mid, type, hideMessage) => {
        if (type === 'redFlag' && taskStatus === TASK_MAIL_STATUS.PROCESSING && !isThreadMail) {
            Toast.info({ content: getIn18Text('WEIWANCHENGDEREN') });
            return;
        }
        if (readOnly) {
            return;
        }
        if (onMark) {
            if (isCorpMail && isThreadMail && threadMailIds && threadMailIds.length) {
                onMark(_mark, threadMailIds, type, hideMessage);
            }
            else {
                onMark(_mark, mid, type, hideMessage);
            }
        }
    });
    const recordMailRead = useCreateCallbackForEvent((id) => {
        const account = typeof mailId === 'string' ? '' : mailId === null || mailId === void 0 ? void 0 : mailId.account;
        mailApi.recordMailRead(id, account);
    });
    const handleDelete = useCreateCallbackForEvent((mid, isThread, params) => {
        var _a;
        if (taskStatus === TASK_MAIL_STATUS.PROCESSING && !isThreadMail) {
            Toast.info({ content: getIn18Text('WEIWANCHENGDEREN') });
            return;
        }
        if (onDelete) {
            let mids = mid;
            if (isCorpMail && isThread && threadMailIds && threadMailIds.length) {
                mids = threadMailIds;
            }
            onDelete(mids, Object.assign({ isScheduleSend: (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.isScheduleSend }, params));
        }
    });
    const onChangeMail = useCreateCallbackForEvent((_keyList) => {
        let keyList = [];
        if (typeof _keyList === 'string') {
            keyList = [_keyList];
        }
        else {
            keyList = _keyList;
        }
        if (keyList.length > activeKey.length) {
            mailActions.doUpdateCurrentMergeMailId(keyList[keyList.length - 1]);
        }
        else if (keyList.length === 0 || keyList[keyList.length - 1] !== activeKey[activeKey.length - 1]) {
            mailActions.doUpdateCurrentMergeMailId('');
        }
        if (keyList.length > activeKey.length) {
            const key = keyList[keyList.length - 1];
            const item = mailListRef.current.find(_ => _.entry.id === key);
            const index = mailListRef.current.findIndex(_ => _.entry.id === key);
            const mid = item === null || item === void 0 ? void 0 : item.entry.id;
            if (item && !item.entry.content.content) {
                mailApi.doGetMailContent(item === null || item === void 0 ? void 0 : item.id, undefined, undefined, undefined, { _account: mailAccount }).then((_content) => {
                    const list = [...mailListRef.current];
                    list[index] = _content;
                    setMailList(list);
                    setActiveKey(keyList);
                    handleTranslateInfo(_content);
                    if ((_content === null || _content === void 0 ? void 0 : _content.entry.readStatus) === 'unread') {
                        if (shouldAutoReadMail) {
                            handleRemark(true, _content.id, 'read', true);
                        }
                        if (process.env.BUILD_ISEDM) {
                            contactType && trackApi.track('waimao_mail_viewUnread_mailDetailPage', { cardType: contactType });
                        }
                    }
                    else {
                        if (shouldAutoReadMail) {
                            recordMailRead(_content.id);
                        }
                    }
                });
            }
            else {
                if (mid && !translateInfoMidMapRef.current[mid]) {
                    handleTranslateInfo(item);
                }
                setActiveKey(keyList);
                if ((item === null || item === void 0 ? void 0 : item.entry.readStatus) === 'unread') {
                    shouldAutoReadMail && handleRemark(true, item === null || item === void 0 ? void 0 : item.id, 'read', true);
                }
                else {
                    shouldAutoReadMail && recordMailRead(item === null || item === void 0 ? void 0 : item.id);
                }
            }
        }
        else {
            setActiveKey(keyList);
        }
    });
    const handleMailDetailRetry = useCreateCallbackForEvent(() => {
        setLoadStatusHandler(MAIL_LOAD_STATUS.LOADING);
        handleIdChange();
    });
    const handleMergeMailOrderChange = useCreateCallbackForEvent((key) => {
        setMergeMailOrderDesc(key == 'desc');
        mailConfApi.doGetUserAttr([MailSettingKeys.nForward]).then(res => {
            if (res === null || res === void 0 ? void 0 : res.ntes_option) {
                const orderKey = res.ntes_option.split('');
                orderKey[15] = key == 'desc' ? '0' : '1';
                mailConfApi.setMailDefaultEncoding(orderKey.join(''));
            }
        });
    });
    const singleUnlockMail = (unlockCont) => {
        const noSysTagContent = filterSysMailTag(unlockCont);
        setContent(noSysTagContent);
    };
    const mergeUnlockMail = (unlockCont) => {
        const noSysTagContent = filterSysMailTag(unlockCont);
        let newMailList = [];
        (mailList || []).forEach(item => {
            if (item.id === noSysTagContent.id) {
                newMailList.push(noSysTagContent);
            }
            else {
                newMailList.push(item);
            }
        });
        setMailList(newMailList);
        setContent(noSysTagContent);
    };
    const debouceMailIdChange = useDebounceForEvent(handleIdChange, 500, {
        leading: true,
        trailing: true,
    });
    useEffect(() => {
        var _a;
        if (tempContent) {
            if (!(content && tempContent.entry.id == ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id)) || content == null) {
                setIsThreadMail(idIsTreadMail(id));
                setThreadMailIds(tempContent.entry.threadMessageIds || []);
                setData(filterSysMailTag(cloneDeep(tempContent)), true);
                setMailList([]);
            }
        }
    }, [(_j = tempContent === null || tempContent === void 0 ? void 0 : tempContent.entry) === null || _j === void 0 ? void 0 : _j.id]);
    useEffect(() => {
        mailIdChangeRecord.current = {
            id: id,
            time: new Date().getTime(),
        };
        debouceMailIdChange();
    }, [id, mergeMailOrderDesc]);
    const MergeMailElement = useMemo(() => content ? (React.createElement(MergeMail, { id: id, searchInputVisible: searchInputVisible, setSearchInputVisible: setSearchInputVisible, activeKey: activeKey, content: content, mailList: mailList, handleDelete: handleDelete, handleRemark: handleRemark, onChangeMail: onChangeMail, readOnly: readOnly, handleTranslateLang: handleTranslateData, translateInfoMidMap: translateInfoMidMap, threadPageConfig: threadPageConfig, onPageChange: handlePageChange, featureConfig: localFeatureConfig, isUpDown: isUpDown, forceUpdate: forceUpdate, ContentMeasurement: ContentMeasurement, VrticalScrollWrapComponent: VrticalScrollWrapComponent, unlockMail: mergeUnlockMail, onOrderChange: handleMergeMailOrderChange, mergeMailOrderDesc: mergeMailOrderDesc, freezeMouse: freezeMouse })) : (React.createElement(React.Fragment, null)), [
        activeKey,
        translateInfoMidMap,
        content,
        threadPageConfig,
        readOnly,
        mailList,
        handlePageChange,
        searchInputVisible,
        setSearchInputVisible,
        forceUpdate,
        mergeMailOrderDesc,
        freezeMouse,
    ]);
    const handleTranslateLangSignleMail = useCallback((toLang, fromLang) => {
        var _a;
        if (readmailFrom === 'marketResultStat') {
            trackApi.track('pc_markting_result_detail_action', { action: 'translate' });
        }
        handleTranslateData((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id, toLang, fromLang);
    }, [(_k = content === null || content === void 0 ? void 0 : content.entry) === null || _k === void 0 ? void 0 : _k.id]);
    const handleTranslateLangSignleMailRef = useCreateCallbackForEvent(handleTranslateLangSignleMail);
    const SingleMailElement = useMemo(() => transMailContent ? (React.createElement(SingleMail, { searchInputVisible: searchInputVisible, nonAttachment: nonAttachment, setSearchInputVisible: setSearchInputVisible, sliceId: sliceId, content: transMailContent, openRecordData: openRecordData, readOnly: readOnly, mailIdChangeRecord: mailIdChangeRecord, translateInfo: translateInfoMidMap[id], handleTranslateLang: handleTranslateLangSignleMailRef, featureConfig: localFeatureConfig, isUpDown: isUpDown, forceUpdate: forceUpdate, unlockMail: singleUnlockMail, source: props.source, readmailFrom: readmailFrom })) : (React.createElement(React.Fragment, null)), [openRecordData, sliceId, readOnly, translateInfoMidMap, localFeatureConfig, searchInputVisible, setSearchInputVisible, forceUpdate, transMailContent, nonAttachment]);
    const clickAction = () => {
        var _a;
        if ((_a = guidePage === null || guidePage === void 0 ? void 0 : guidePage.btn) === null || _a === void 0 ? void 0 : _a.action) {
            guidePage.btn.action();
        }
    };
    const DefaultEmptyElement = useMemo(() => {
        var _a;
        let showBtn = false;
        const { btn } = guidePage;
        if (btn) {
            const { judgeShowBtn } = btn;
            if (judgeShowBtn) {
                showBtn = judgeShowBtn();
            }
            else {
                showBtn = true;
            }
        }
        return (React.createElement("div", { className: "u-message-empty no-select dark-img-invert-grayscale" },
            React.createElement("img", { src: guidePage.imgUrl, alt: "empty" }),
            React.createElement("div", { className: "u-empty-title" }, guidePage.title),
            React.createElement("div", { className: "u-empty-text" }, guidePage.desc),
            showBtn && React.createElement("div", { onClick: clickAction, dangerouslySetInnerHTML: { __html: safeHTML(((_a = guidePage === null || guidePage === void 0 ? void 0 : guidePage.btn) === null || _a === void 0 ? void 0 : _a.txt) || '') } })));
    }, [guidePage, openInNewWindow]);
    const DefaultErrorElement = useMemo(() => (React.createElement("div", { className: "mail-detail-error-warp" },
        React.createElement("div", { className: "sirius-empty sirius-empty-doc" }),
        React.createElement("div", { className: "md-error-tip" }, getIn18Text('JIAZAISHIBAI')),
        React.createElement("div", { className: "md-btn-warp" },
            React.createElement(Button, { type: "link", onClick: handleMailDetailRetry }, getIn18Text('ZHONGSHI'))))), []);
    const emptyRenderRef = useStateRef(emptyRender);
    const EmptyElement = useMemo(() => {
        if (emptyRenderRef.current) {
            if (typeof emptyRenderRef.current === 'function') {
                const element = emptyRender();
                if (element) {
                    return element;
                }
                else {
                    return DefaultEmptyElement;
                }
            }
            else {
                return emptyRenderRef.current;
            }
        }
        return DefaultEmptyElement;
    }, [DefaultEmptyElement]);
    const failRenderRef = useStateRef(failRender);
    const ErrorElement = useMemo(() => {
        if (failRenderRef.current) {
            if (typeof failRenderRef.current === 'function') {
                return failRenderRef.current({
                    error: loadFailError,
                    retry: handleMailDetailRetry,
                });
            }
            else {
                return failRenderRef.current;
            }
        }
        return DefaultErrorElement;
    }, [DefaultErrorElement, loadFailError]);
    const LoadingElement = useMemo(() => {
        if (loadingRender) {
            if (typeof loadingRender === 'function') {
                const res = loadingRender();
                if (res) {
                    return res;
                }
                else {
                    return React.createElement(MailDetailLoading, null);
                }
            }
            else {
                return loadingRender;
            }
        }
        return React.createElement(MailDetailLoading, null);
    }, [loadingRender]);
    const handleHKCommandF = useCallback((e) => {
        e.preventDefault();
        if (content === null || content === void 0 ? void 0 : content.isEncryptedMail) {
            Toast.info({ content: '加密邮件暂不支持正文搜索' });
            return;
        }
        setSearchInputVisible(true);
    }, [content === null || content === void 0 ? void 0 : content.isEncryptedMail]);
    useEffect(() => {
        if (inWindow()) {
            if (!window.readMail)
                window.readMail = {};
            window.readMail.keyEvent = e => {
                if (e.key === 'f' && (e.metaKey || e.ctrlKey)) {
                    if (content === null || content === void 0 ? void 0 : content.isEncryptedMail) {
                        Toast.info({ content: '加密邮件暂不支持正文搜索' });
                        return;
                    }
                    setSearchInputVisible(true);
                }
            };
        }
    }, [setSearchInputVisible, content === null || content === void 0 ? void 0 : content.isEncryptedMail]);
    const handleHKCommandFRef = useCreateCallbackForEvent(handleHKCommandF);
    const listHotKeyHandler = useMemo(() => {
        return {
            [ListHotKey.COMMAND_F]: handleHKCommandFRef,
        };
    }, []);
    const activeIdRef = useStateRef(mailId);
    const hkParams = useMemo(() => {
        return {
            handler: {
                [HotKeysType.XUANZHONGYOUJIANXIN]: () => {
                    var _a;
                    dispatch(Thunks.openMailInNewWindow((_a = activeIdRef.current) === null || _a === void 0 ? void 0 : _a.id));
                },
                [HotKeysType.BIAOJIYIDU]: () => {
                    var _a, _b;
                    eventApi.sendSysEvent({
                        eventName: 'mailStatesChanged',
                        eventData: {
                            mark: true,
                            id: (_a = activeIdRef.current) === null || _a === void 0 ? void 0 : _a.id,
                            type: 'read',
                        },
                        _account: (_b = activeIdRef.current) === null || _b === void 0 ? void 0 : _b.account,
                        eventStrData: 'read',
                    });
                },
                [HotKeysType.BIAOJIWEIDU]: () => {
                    var _a, _b;
                    eventApi.sendSysEvent({
                        eventName: 'mailStatesChanged',
                        eventData: {
                            mark: false,
                            id: (_a = activeIdRef.current) === null || _a === void 0 ? void 0 : _a.id,
                            type: 'read',
                        },
                        _account: (_b = activeIdRef.current) === null || _b === void 0 ? void 0 : _b.account,
                        eventStrData: 'unread',
                    });
                },
                [HotKeysType.DUXINSHANGYIF]: () => {
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventStrData: 'OnPrevMail',
                    });
                },
                [HotKeysType.DUXINXIAYIF]: () => {
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventStrData: 'OnNextMail',
                    });
                },
                [HotKeysType.HUIFU]: () => {
                    var _a, _b;
                    const mail = getMailFromMails(contentRef.current);
                    const { _account, owner, mailFrom } = mail || {};
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { opt: 'replay' },
                        eventStrData: 'closeCurReadTab_before',
                        _account,
                    });
                    return mailApi
                        .doReplayMail((_a = activeIdRef.current) === null || _a === void 0 ? void 0 : _a.id, false, undefined, undefined, (_b = activeIdRef.current) === null || _b === void 0 ? void 0 : _b.account, { owner: mailFrom === 'subordinate' ? owner : '' })
                        .then(res => {
                        eventApi.sendSysEvent({
                            eventName: 'mailMenuOper',
                            eventData: { opt: 'replay' },
                            eventStrData: 'closeCurReadTab_after',
                            _account,
                        });
                        return res;
                    });
                },
                [HotKeysType.HUIFUQUANBU]: () => {
                    var _a;
                    const mail = getMailFromMails(contentRef.current);
                    const { _account, mailFrom, owner } = mail;
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { opt: 'replayAll' },
                        eventStrData: 'closeCurReadTab_before',
                        _account,
                    });
                    return mailApi.doReplayMail((_a = activeIdRef.current) === null || _a === void 0 ? void 0 : _a.id, true, undefined, undefined, _account, { owner: mailFrom === 'subordinate' ? owner : '' }).then(res => {
                        eventApi.sendSysEvent({
                            eventName: 'mailMenuOper',
                            eventData: { opt: 'replayAll' },
                            eventStrData: 'closeCurReadTab_after',
                            _account,
                        });
                        return res;
                    });
                },
                [HotKeysType.ZHUANFA]: () => {
                    var _a;
                    const mail = getMailFromMails(contentRef.current);
                    const { _account, owner, mailFrom } = mail;
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { opt: 'forward' },
                        eventStrData: 'closeCurReadTab_before',
                        _account,
                    });
                    return mailApi.doForwardMail((_a = activeIdRef.current) === null || _a === void 0 ? void 0 : _a.id, { _account, owner: mailFrom === 'subordinate' ? owner : '' }).then(res => {
                        eventApi.sendSysEvent({
                            eventName: 'mailMenuOper',
                            eventData: { opt: 'forward' },
                            eventStrData: 'closeCurReadTab_after',
                            _account,
                        });
                        return res;
                    });
                },
            },
            disabled: !!readOnly || visible === false,
        };
    }, [readOnly, visible]);
    useRegistMailHK(MAIL_HOTKEY_MODULE_TYPE.MAIL_DETAIL_CSTOM, hotKey ? hkParams : undefined);
    return (React.createElement(HotKeys, { keyMap: keyMap, handlers: listHotKeyHandler, style: { width: '100%', height: '100%' } },
        React.createElement(WrapCompenent, { className: 'u-read-wrapper ' + (isThreadMail && mailList.length ? 'thread' : 'single'), style: {
                height: '100%',
            } },
            loadStatus == MAIL_LOAD_STATUS.SUCCESS ? isThreadMail ? MergeMailElement : SingleMailElement : React.createElement(React.Fragment, null),
            loadStatus == MAIL_LOAD_STATUS.EMPTY ? EmptyElement : React.createElement(React.Fragment, null),
            loadStatus == MAIL_LOAD_STATUS.FAIL ? ErrorElement : React.createElement(React.Fragment, null),
            loadStatus == MAIL_LOAD_STATUS.LOADING ? LoadingElement : React.createElement(React.Fragment, null),
            React.createElement(AttachmentPreview, null),
            isThreadMail ? (React.createElement("div", { style: { position: 'absolute', width: '100%', bottom: '2px', zIndex: 100 } },
                React.createElement(HorizontalScrollBar, { viewWidth: vScrollBarViewWidth, scrollWidth: vScrollBarWidth, scrollLeft: vScrollBarLeft, onScroll: handleVScrollOnScroll, show: vScrollBarShow, horizontalPadding: 20, onDragStart: () => {
                        setFreezeMouse(true);
                    }, onDragEnd: () => {
                        setFreezeMouse(false);
                    } }))) : (React.createElement(React.Fragment, null)))));
};
export default ReadMail;
